var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"hello"},[_vm._v("Hello "+_vm._s(_vm.name)+" "+_vm._s(_vm.$attrs))])])}
var staticRenderFns = []

export { render, staticRenderFns }